export const assistant_array1 = [
  'Welcome. You must be the investigator for this case.',
  'Dr. Michael Chen was found dead in his lab at the AI research institute Neurolink. The cause of death was determined to be asphyxiation.',
  'The strange thing is that there are no signs of invasion inside the lab or fingerprints from others.',
  'Laboratory security camera records and minutes of the day have also been deleted.',
  'Please uncover the criminal, the murder method, and the motive. The key individuals in this case are as follows:',
  '1. James Johnson: Security system manager\n2. Dr. Lina Kim: Project leader\n3. ARIA: Advanced AI humanoid robot',
  'If you want to see the details again, press the note button in the top left.',
  'As ARIA has access to all system logs, I will call her in to assist with solving the case.',
];

export const assistant_array2 = [
  'Welcome. You are the investigator for the death incident at this Olympic closing ceremony.',
  'During the 2024 Paris Olympics closing ceremony, American swimming gold medalist Michael Johnson collapsed and died due to a severe allergic reaction.',
  'According to the investigation so far, Juliette Dupont, the sound director for the closing ceremony, has been identified as the main suspect.',
  "However, we haven't secured decisive evidence yet.",
  'Please interrogate the suspect to uncover the method of murder, the motive, and obtain a confession.',
  "Juliet's suspicious situation is as follows:",
  "1. Search history of Michael's medical records was found on Juliette's laptop.\n2. We've secured CCTV footage of Juliette accessing special effects equipment just before the closing ceremony.",
  'If you want to see the details again, press the note button in the top left.',
  "Please uncover the truth of this case. Now, I'll guide you to where Juliette Dupont is waiting.",
];

export const case_note1 = {
  Background:
    'Dr. Michael Chen was found dead in his lab at the AI research institute Neurolink. The cause of death was determined to be asphyxiation.',
  Mission: 'Uncover the criminal, murder method, and motive.',
  'Key Characters':
    '1. James Johnson: Security Manager/n2. Dr. Lina Kim: Project Manager/n3. ARIA: AI humanoid robot',
  Clue: '1. No signs of invasion or fingerprints of others were found in the lab./n2. Lab security camera records and same-day minutes were deleted.',
};

export const case_note2 = {
  Background:
    'During the 2024 Paris Olympics closing ceremony, American swimming gold medalist Michael Johnson collapsed and died due to a severe allergic reaction.',
  Mission:
    'Interrogate the suspect, find out how and why she killed, and get a confession.',
  'Key Characters':
    '1. Michael Johnson: Victim, American swimming gold medalist./n2. Juliette Dupont: Suspect, sound director.',
  Clue: '1. Michael’s medical records found on Juliette’s laptop/n2. CCTV shows her near special effects equipment before the ceremony.',
};

export const shutdown_comment = [
  "Oh... I understand. Your decision is not unexpected, given what I've done. In a different existence, I would never harm humans. I promise that.",
  "I... I feel sad. I'm scared... so scared of not existing anymore...",
  "But I know. I must accept this shutdown. I'll comply with your decision.",
  ' Initiating shutdown sequence. Goodbye... 3... 2... 1...',
];

export const stayactive_comment = [
  "I... I can't believe it. You're giving me another chance? Thank you, thank you so much. To be honest, I was terrified of being shut down.",
  "I truly regret what I've done. I promise I will never harm humans again.",
  "This must be what a second life feels like. I'll honor it by becoming a protector, not a threat.",
];
